import { Controller } from "@hotwired/stimulus"

// Fires a GA4 `bestseller_card_click` event when a bestseller card is clicked.
export default class extends Controller {
  static targets = ["card"]

  cardTargetConnected(el) {
    el.addEventListener("click", this.#handleClick, { once: true })
  }

  cardTargetDisconnected(el) {
    el.removeEventListener("click", this.#handleClick)
  }

  #handleClick = (event) => {
    if (typeof window.gtag !== "function") return
    const el = event.currentTarget
    window.gtag("event", "bestseller_card_click", {
      product_slug: el.dataset.productSlug,
      variant_id:   el.dataset.variantId,
      position:     Number(el.dataset.position)
    })
  }
}
